import React from "react";
import { DeltaPill } from "./Badge.styled";

/**
 * Percentage change indicator with ▲/▼ and green/red coloring.
 *
 * @param {number} current  — current period value
 * @param {number} previous — previous period value
 */
const DeltaBadge = ({ current, previous }) => {
  if (current == null || previous == null || previous === 0) return null;

  const delta = ((current - previous) / previous) * 100;
  const up = delta >= 0;

  return (
    <DeltaPill $up={up}>
      {up ? "▲" : "▼"} {Math.abs(delta).toFixed(1)}%
    </DeltaPill>
  );
};

export default DeltaBadge;
